import { InfoCircleFilled, SettingOutlined } from "@ant-design/icons";
import { Badge, Popover, Switch, Tag } from "antd";
import OffsetIcon from "components/svg-icons/offset-icon";
import React, { useState } from "react";
import "./index.scss";

type ActivityItemType = {
  opt_title: string;
  opt_subtitle: string;
  opt_img: React.ReactNode;
  onChangeAction: () => void;
};

function AIAdvanceLinkingSettings(props: {
  onWBSEnableAction: any;
  isWBSLinkExist: boolean;
}) {
  const { onWBSEnableAction, isWBSLinkExist } = props;
  const [open, setOpen] = useState(false);

  const menuItem = (option: ActivityItemType) => {
    return (
      <div className="flex skip-listing-window ">
        <div className="flex p-2 px-5 space-y-2">
          <div
            className="flex-col w-60 "
            data-testid="linking-ai-advance-settings-wbs-tag-container"
          >
            <div className="text-black text-opacity-90 font-medium text-sm">
              {option.opt_title}
            </div>
            <div className="text-ciq-gray-900 text-xs pr-7">
              {option.opt_subtitle}
            </div>
            {isWBSLinkExist && (
              <Tag
                className="flex space-x-2 text-black text-opacity-90 text-sm max-w-full whitespace-normal mt-2 rounded-lg p-2"
                color="blue"
                data-testid="linking-ai-advance-settings-wbs-tag"
              >
                <span>
                  <InfoCircleFilled style={{ color: "var(--ciq-info)" }} />
                </span>
                <span> Any links to WBS/Milestones will be retained.</span>
              </Tag>
            )}
          </div>
          <Switch
            style={{ color: "var(--ciq-info)" }}
            onChange={option.onChangeAction}
            data-testid="linking-ai-advance-settings-wbs-switch"
          />
        </div>
      </div>
    );
  };

  return (
    <div className="flex aiAdvanceSetting">
      <Popover
        open={open}
        trigger="click"
        onOpenChange={(visible) => setOpen(visible)}
        className="px-1 flex"
        placement="rightTop"
        classNames={{ root: "popoverNoPadding" }}
        styles={{ container: { borderRadius: "6px" } }}
        data-testid="linking-ai-advance-settings-popover"
        content={
          <div className="flex flex-col">
            <div className="pl-5 py-3 text-black text-opacity-40 font-semibold text-xs">
              Advanced Settings
            </div>
            {menuItem({
              opt_title: "Link to WBS",
              opt_subtitle: "Enable linking to WBS/Milestone nodes.",
              opt_img: <OffsetIcon />,
              onChangeAction: onWBSEnableAction
            })}
          </div>
        }
      >
        <Badge status="default" offset={[-5, 0]} dot={isWBSLinkExist}>
          <SettingOutlined
            title="Advanced Settings"
            className="cursor-pointer z-10"
          />
        </Badge>
      </Popover>
    </div>
  );
}
export default AIAdvanceLinkingSettings;
